import { toast } from 'react-toastify';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { mergeMap, switchMap } from 'rxjs/operators';

import {
  AddInterstedFailure,
  AddInterstedSuccess,
  EditInterstedFailure,
  EditInterstedSuccess,
} from '../../Redux/Actions/InterstedAction';
import { ADD_INTRESTED, EDIT_INTRESTED } from '../../Redux/Actiontype';
import routeRules from '../../Routes/routeRules';
import history from '../../Store/history';
import { Basepath } from '../../config';

const clearSession = msg => {
  localStorage.clear();
  alert(msg);
  window.location = '/';
};
export const AddInterstedEpic = action$ =>
  action$.pipe(
    ofType(ADD_INTRESTED),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/addInterested`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              history.push(routeRules.interstedmanagement, toast.success(response.response.message));
              return of(AddInterstedSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              console.log(response.response);
              return of(AddInterstedFailure(response.response));
            }
          }),
        ),
    ),
  );
export const EditInterstedEpic = action$ =>
  action$.pipe(
    ofType(EDIT_INTRESTED),
    switchMap(action =>
      ajax
        .post(`${Basepath}/api/admin/editIntersted`, action.payload, {
          authentication: localStorage.getItem('sessionId'),
        })
        .pipe(
          mergeMap(response => {
            if (response.response.statusCode === 200) {
              return of(EditInterstedSuccess(response.response));
            } else if (response.response.statusCode == 401) {
              clearSession(response.response.message);
            } else {
              return of(EditInterstedFailure(response.response));
            }
          }),
        ),
    ),
  );
